/* eslint-disable */
/* eslint-enable no-undef */
import sinon from "sinon-legacy";
import Promise from "bluebird";
import _ from "underscore";
function stub(schemas) {
  var jsdataMock = {
    "schemas": schemas,
    "Intermediate": {
      getAll: sinon.stub(),
      subscribe: sinon.stub()
    }
  };
  jsdataMock.mockPromise = function () {
    var promise = new Promise(function (resolve, reject) {
      resolve = sinon.stub().returns({});
      reject = sinon.stub().returns({});
    });
    promise.resolve = sinon.stub().returns({});
    promise.reject = sinon.stub().returns({});
    return promise;
  };
  jsdataMock.stubSchema = function () {
    return {
      create: sinon.stub().returns(this.mockPromise()),
      createMany: sinon.stub().returns(this.mockPromise()),
      find: sinon.stub().returns(this.mockPromise()),
      findAll: sinon.stub().returns(this.mockPromise()),
      update: sinon.stub().returns(this.mockPromise()),
      updateMany: sinon.stub().returns(this.mockPromise()),
      updateAll: sinon.stub().returns(this.mockPromise()),
      destroy: sinon.stub().returns(this.mockPromise()),
      destroyAll: sinon.stub().returns(this.mockPromise())
    };
  };
  _.each(jsdataMock.schemas, function (schema, index) {
    jsdataMock[schema] = jsdataMock.stubSchema();
  });
  jsdataMock.restore = (function () {
    _.each(this.schemas, (function (schema, index) {
      this[schema] = this.stubSchema();
    }).bind(this));
  }).bind(jsdataMock);
  jsdataMock.resetStub = (function () {
    _.each(jsdataMock.schemas, function (schema, index) {
      _.each(jsdataMock[schema], function (spy, action) {
        jsdataMock[schema][action].reset();
      });
    });
  }).bind(jsdataMock);
  jsdataMock.mockResolve = (function (schema, method, result) {
    if (!_.contains(this.schemas, schema) || !_.has(this[schema], method)) {
      return;
    }
    this[schema][method] = sinon.stub().returns(new Promise(function (resolve, reject) {
      resolve(result);
    }));
  }).bind(jsdataMock);
  return jsdataMock;
}
export default {
  stub: stub
};

